import * as actionTypes from '../actions/actionTypes';

const DEFAULT_STATE = {
  results: [],
  loading: false,
  updatedAt: null,
};

const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return DEFAULT_STATE;
    case actionTypes.FETCH_MINING_WORKERS_SUCCESS:
      return {
        ...state,
        results: action.payload,
        loading: false,
        updatedAt: new Date(),
      };
    case actionTypes.FETCH_MINING_WORKERS_FAILED: {
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.FETCH_MINING_WORKERS: {
      return {
        ...state,
        loading: true,
      };
    }
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// /src/redux/reducers/workersReducer.js